export const darkAttributeColour = '#B76BE0';
export const earthAttributeColour = '#885513';
export const electricAttributeColour = '#FDD209';
export const fireAttributeColour = '#E03D0B';
export const lightAttributeColour = '#FFFCE7';
export const neutralAttributeColour = '#5F5E5F';
export const plantAttributeColour = '#48D52D';
export const waterAttributeColour = '#3EA1F7';
export const windAttributeColour = '#96FCD5';
